/**
 * @typedef Totals
 * @property totalExcVat - The total excluding VAT
 * @property totalVat - The total VAT
 * @property totalIncVat - The total including VAT
 */
const calculateVatPercentage = (vat?: string): number => {
  if (!vat || !vat.includes("%")) return 0;
  try {
    const vatPercentage = parseInt(vat, 10);
    return vatPercentage;
  } catch (e) {
    return 0;
  }
};

export interface LineItemCalculatedTotal {
  totalExcVat: number;
  totalVat: number;
  totalIncVat: number;
}

/**
 * Calculates item total from parts
 *
 * @param quantity Quantity for item, in units e.g. 100 = 1.00 (default)
 * @param price Price for item, in pence
 * @param vat Vat for item
 */
export const calculateItemTotal = (
  quantity = 0,
  price = 0,
  vat?: string,
  vatAmount = 0,
  quantityDecimal = 100
): LineItemCalculatedTotal => {
  // Get VAT percentage
  const vatPercentage = calculateVatPercentage(vat);
  // Calculate exc-VAT total
  const totalExcVat =
    // Quantity times price, over quantityDecimal
    Math.round((quantity * price) / quantityDecimal);

  if (vat === "custom") {
    const roundedVat = Math.round(vatAmount);
    return {
      totalExcVat,
      totalVat: roundedVat,
      totalIncVat: totalExcVat + roundedVat,
    };
  }
  // returns if no VAT to add
  if (vatPercentage === null) {
    return {
      totalExcVat,
      totalVat: 0,
      totalIncVat: totalExcVat,
    };
  }

  // Calculate VAT total
  const totalVat = Math.round((totalExcVat * vatPercentage) / 100);
  // Calculate total (incl. VAT)
  const totalIncVat = Math.round(totalExcVat + totalVat);
  return {
    totalExcVat,
    totalVat,
    totalIncVat,
  };
};
